<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>Carrier Income Report</h2>
    </div>
    <div class="ibox-content report-box" style="min-height: 125px">
      <div class="row">
        <div class="col-xs-12">
          <div class="m-b-md">
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="all_time"
                name="carrier_income_period"
                id="carrier_income_period_all_time">

              <label for="carrier_income_period_all_time">All Time</label>
            </div>
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="date_range"
                name="carrier_income_period"
                id="carrier_income_period_range">
              <label for="carrier_income_period_range">Date Range</label>
            </div>
          </div>

          <div class="form-group" v-show="periodSelectedIsDateRange">
            <date-range
              v-model="dateRange"
              :max-date="yesterday"
              name="date_range">
            </date-range>
          </div>

          <div v-if="!$user.isCarrier" class="form-group" :class="{ 'has-error': errors.has('carrier') }">
            <selectize
              :options="[]"
              :fetch-results="fetchCarrierResults"
              v-model="carrier"
              pre-load="focus"
              placeholder="Search for carrier..."
              name="carrier"
              v-validate="'required'">
            </selectize>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox-footer text-right">
      <ladda-button
        :on-click="handleGenerateReport"
        class="btn btn-primary btn-sm">
        <i class="fa fa-cloud-download fa-fw"></i> Download PDF
      </ladda-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { DateRange, Selectize, LaddaButton } from 'components/forms'
  import { notify } from 'utils'
  import { clone, map } from 'lodash'
  import moment from 'moment'

  export default {
    components: {
      DateRange,
      Selectize,
      LaddaButton
    },

    data () {
      return {
        period: 'all_time',
        dateRange: {
          from: null,
          to: null
        },
        carrier: null,
        carriers: []
      }
    },

    watch: {
      period () {
        if (this.period === 'all_time') {
          this.dateRange = {
            from: null,
            to: null
          }
        } else {
          this.dateRange = {
            from: moment().startOf('month').format('DD/MM/YYYY'),
            to: moment().subtract(1, 'day').format('DD/MM/YYYY')
          }
        }
      }
    },

    created () {
      if (this.$user.isCarrier) {
        this.carrier = this.$user.id
      }
    },

    computed: {
      ...mapGetters('user', ['userOptions']),

      yesterday () {
        return moment().subtract(1, 'day')
      },

      periodSelectedIsDateRange () {
        return this.period === 'date_range'
      },

      generatePayload () {
        return {
          carrier: this.carrier,
          from: this.dateRange.from ? this.dateRange.from : null,
          to: this.dateRange.to ? this.dateRange.to : null
        }
      },

      /**
       * Carrier options.
       *
       * @return array
       */
      carrierOptions () {
        return map(this.carriers, carrier => ({ id: carrier.id, text: carrier.profile.company_name }))
      }
    },

    methods: {
      ...mapActions('carrier', ['getCarriers']),
      ...mapActions('report', ['generateCarrierIncomeReport']),

      /**
       * Fetch carriers from the API.
       *
       * @return Promise
       */
      fetchCarrierResults (name, callback) {
        return this.getCarriers({ name, verified: true }).then(response => {
          this.carriers = clone(response)
          callback(this.carrierOptions)
        })
      },

      handleGenerateReport () {
        return this.validateAll().then(response => {
          const listenForReportGenerated = () => {
            notify.success('Please wait while we get your download ready.')
          }

          return this.generateCarrierIncomeReport(this.generatePayload).then(listenForReportGenerated)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CarrierIncomeReport.vue?39b8ca18